import { OidcClient } from "@axa-fr/oidc-client"
import axios from "axios"

export const client = axios.create({
  baseURL: process.env.REACT_APP_API_URL,
  headers: {
    "Content-Type": "application/json",
    Accept: "application/json"
  }
})

client.interceptors.request.use(
  (config) => {
    const { tokens } = OidcClient.get()

    if(tokens === null || tokens?.accessToken == null) {
        return Promise.reject(new Error("There is no access tokens"))
    }

    if (tokens?.accessToken && config.headers) {
      config.headers.Authorization = `Bearer ${tokens.accessToken}`
    }

    return config
  },
  (error) => {
    return Promise.reject(error)
  }
)

const UNAUTHORIZED = 401

client.interceptors.response.use(
  (response) => response.data,
  (error) => {
    const status = error.response?.status

    if (status === UNAUTHORIZED) {
      sessionStorage.clear()

      const oidc = OidcClient.get()

      if(oidc.tokens === null || oidc.tokens?.accessToken == null) {
        // если уже нет токенов (logout был уже вызван ранее), то logout будет с ошибкой, поэтому возвращаем ошибку до logout
        return Promise.reject(new Error("There is no access tokens"))
      }

      oidc.logoutAsync()
    }
    else
      return Promise.reject(error)
  }
)
